import React, { useCallback, useMemo, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import AppRouter from "./router";
import WaitlistModal from "./components/WaitlistModal";
import Toast from "./components/Toast";

export default function App() {
  const [modalOpen, setModalOpen] = useState(false);
  const [ctaSource, setCtaSource] = useState("unknown");
  const [toast, setToast] = useState(null);

  const openModal = useCallback((source) => {
    setCtaSource(source || "unknown");
    setModalOpen(true);
  }, []);

  const closeModal = useCallback(() => setModalOpen(false), []);

  const toastApi = useMemo(() => {
    return {
      show: (type, message) => setToast({ type, message }),
      clear: () => setToast(null),
    };
  }, []);

  return (
    <BrowserRouter>
      <AppRouter onOpenModal={openModal} />
      <WaitlistModal
        isOpen={modalOpen}
        onClose={closeModal}
        sourceCta={ctaSource}
        toastApi={toastApi}
      />
      <Toast toast={toast} onClose={toastApi.clear} />
    </BrowserRouter>
  );
}
